import { useSelectedObject } from './useSelectedObject';

export const useIsSelected = (path: string) => {
  const { isObjectSelected } = useSelectedObject();
  const isSelected = isObjectSelected(path);

  return { isSelected };
};
